import { Inputs, validationSchema } from '@/entities/PlayersOfPeriod/PlayersOfPeriodFormInputs'

const PlayersOfPeriod = {
	Plural: 'PlayersOfPeriod',
	Single: 'PlayersOfPeriod',
	Inputs: Inputs,
	IsPage: true,
	UpdateMethod: 'patch',
	Relationships: [],
	ValidationSchema: validationSchema,
	SaveCallBack: () => { /* noop */ }
};

export default PlayersOfPeriod;
